// ---------------------------------------------------------------------------
// D.3: Mobile Bottom Navigation
// ---------------------------------------------------------------------------
// Bottom nav bar on mobile for primary actions (visible < 768px).
// Desktop: hidden. Mobile: fixed bottom with 5 primary module icons.
// ---------------------------------------------------------------------------

import { useLocation, useNavigate } from "react-router";
import type { LucideIcon } from "lucide-react";
import { FileText, Inbox, LayoutDashboard, Settings, Users } from "lucide-react";

const NAV_ITEMS = [
  { path: "/dashboard", label: "Home", Icon: LayoutDashboard },
  { path: "/inbox", label: "Inbox", Icon: Inbox },
  { path: "/crm/contacts", label: "CRM", Icon: Users },
  { path: "/pages", label: "Pages", Icon: FileText },
  { path: "/settings", label: "More", Icon: Settings },
] satisfies ReadonlyArray<{ path: string; label: string; Icon: LucideIcon }>;

export function MobileBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-border bg-background md:hidden">
      <div className="flex items-center justify-around py-2">
        {NAV_ITEMS.map((item) => {
          const isActive = location.pathname.startsWith(item.path);
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex min-h-[48px] min-w-[48px] flex-col items-center justify-center gap-0.5 rounded-md px-3 py-1 ${
                isActive ? "text-primary" : "text-muted-foreground"
              }`}
            >
              <item.Icon className="h-5 w-5" aria-hidden="true" />
              <span className="text-[10px] font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
